import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'app/components/base.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { Observable } from 'rxjs';
import { buildViewCampaignQCCalls } from './campaign-detail.util';
import {
  SmartQcService,
  CampaignQC,
  ViewCampaignQCCall,
  GetQuery,
  QCCallStatus,
} from 'app/common/services/SmartQC.service';
import { TableAction } from 'app/components/table-component/table.const';
import { buildTableColumns } from './campaign-detail.util';

@Component({
  selector: 'app-smart-qc-campaign-detail',
  templateUrl: './campaign-detail.component.html',
  styleUrls: ['./campaign-detail.component.css'],
  providers: [SmartQcService],
})
export class CampaignDetailComponent extends BaseComponent {
  private _campaignQCId: string;
  public loading: boolean = false;
  public campaignQC: CampaignQC;
  public tableColumns: any[] = [];
  public viewCampaignQCCalls: ViewCampaignQCCall[] = [];
  public selectedCampaignQCCallIds: string[] = [];
  public totalItem: number = 0;
  public totalPage: number = 0;
  public pageSize: number = 10;
  public currentPage: number = 1; // Set a default value

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private smartQCService: SmartQcService
  ) {
    super(changeDetector, toastr, modalService);
  }

  ngOnInit() {
    this.loading = false;

    this.tableColumns = buildTableColumns();

    this.activeRoute.paramMap.subscribe(params => {
      const campaignQCId = params.get('id');
      if (campaignQCId) {
        this._campaignQCId = campaignQCId;

        this.loading = true;

        Observable.forkJoin([
          this.smartQCService.getCampaignQC(campaignQCId),
          this.smartQCService.getCampaignQCCalls(campaignQCId, {
            page: this.currentPage,
            page_size: this.pageSize,
          }),
        ]).subscribe(
          results => {
            this.loading = false;

            const [getCampaignQCResult, getCampaignQCCallsResult] = results;
            this.campaignQC = getCampaignQCResult.data;

            const { data, total } = getCampaignQCCallsResult.data;
            this.totalItem = total;
            this.totalPage = Math.ceil(total / this.pageSize);
            const startIndex = (this.currentPage - 1) * this.pageSize;
            this.viewCampaignQCCalls = buildViewCampaignQCCalls(data, startIndex);
          },
          error => {
            this.loading = false;
            this.throwError(error.message);
          }
        );
      }
    });
  }

  async getQCCalls() {
    this.loading = true;

    const query: GetQuery = {
      page: this.currentPage,
      page_size: this.pageSize,
    };

    return this.smartQCService.getCampaignQCCalls(this._campaignQCId, query).subscribe(
      ({ data }) => {
        this.loading = false;
        this.totalItem = data.total;
        this.totalPage = Math.ceil(data.total / this.pageSize);
        const rowIndex = (this.currentPage - 1) * this.pageSize;
        this.viewCampaignQCCalls = buildViewCampaignQCCalls(data.data, rowIndex);
      },
      error => {
        this.loading = false;
        this.throwError(error.message);
      }
    );
  }

  async handleTableAction(event: TableAction, viewCampaignQCCall: ViewCampaignQCCall) {
    if (event === TableAction.view) {
      if (viewCampaignQCCall.status === QCCallStatus.RECEIVE_FROM_EMAS) {
        const qcTicketId = viewCampaignQCCall._id;
        this.router.navigate(['/smart-qc/campaigns', this._campaignQCId, 'calls', qcTicketId]);
      } else {
        alert('Chưa nhận được kết quả xử lý');
      }
      // const qcTicketId = viewCampaignQCCall._id;
      // this.router.navigate(['/smart-qc/campaigns', this._campaignQCId, 'calls', qcTicketId]);
    }
  }

  async handleExport() {
    if (!this.selectedCampaignQCCallIds.length) {
      this.throwError('Cần chọn cuộc gọi để xuất thông tin');
    } else {
      this.smartQCService
        .exportCSV(this._campaignQCId, this.selectedCampaignQCCallIds)
        .then(blob => {
          const link = document.createElement('a');
          const downloadURL = window.URL.createObjectURL(blob);
          link.href = downloadURL;
          link.download = `campaign-qc-${this._campaignQCId}-calls.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadURL);

          this.throwSuccess('Export thành công!');
        })
        .catch(e => {
          this.throwError(e.message);
        });
    }
  }

  handleGoBack() {
    this.router.navigate(['/smart-qc/campaigns']);
  }

  handleCheckRow(event: string, selectedCampaignQCCallId?: string) {
    if (event === 'all') {
      this.selectedCampaignQCCallIds = this.viewCampaignQCCalls.map(vqc => vqc._id);
    } else if (event === 'row') {
      const selectedIndex = this.selectedCampaignQCCallIds.indexOf(selectedCampaignQCCallId);
      if (selectedIndex === -1) {
        this.selectedCampaignQCCallIds.push(selectedCampaignQCCallId);
      } else {
        this.selectedCampaignQCCallIds.splice(selectedIndex, 1);
      }
    }
  }

  setPage(page: number) {
    let newPage: number = page;
    if (page < 1) {
      newPage = 1;
    }

    if (page > this.totalPage) {
      newPage = this.totalPage;
    }

    if (newPage !== this.currentPage) {
      this.currentPage = newPage;
      this.selectedCampaignQCCallIds = [];
      this.getQCCalls();
    }
  }

  goPage2(page: string) {
    let toPage: any = page;
    if (!toPage) {
      toPage = 1;
    }

    if (Number.isInteger(toPage) && toPage <= 0) {
      toPage = 1;
    }

    this.setPage(toPage);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/campaign/campaign-detail/campaign-detail.component.ts